import { IconProductVasStandard16, IconVasAuction16, IconVasPremium16, IconVasTop16 } from '@cian/ui-kit';

import type { VasListItem } from '../../types';

export function getAuctionVasListItem(title: string | null): VasListItem {
  const id = 'auction';

  const icon = <IconVasAuction16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  const vasListItem: VasListItem = {
    icon,
    id,
    tooltip: {
      description:
        'С помощью ставки сверх Топа можно привлечь ещё больше внимания. Чем выше ставка, тем чаще ваше объявление будет показано в результатах поиска.',
      icon,
      title: 'Аукцион',
    },
  };

  if (title) {
    vasListItem.title = title;
  }

  return vasListItem;
}

export function getPremiumVasListItem(): VasListItem {
  const id = 'premium';

  const icon = <IconVasPremium16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    title: 'Премиум',
    tooltip: {
      description:
        'Объявления с продвижением Премиум заметнее за счёт авторского заголовка и выше Стандарта и Публикаций в результатах поиска.',
      icon,
      title: 'Премиум',
    },
  };
}

export function getTop3VasListItem(): VasListItem {
  const id = 'top3';

  const icon = <IconVasTop16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    title: 'Топ',
    tooltip: {
      description:
        'Объявления с продвижением Топ заметнее за счёт авторского заголовка и больших фотографий. В поиске они выше Премиума, Стандарта и обычных Публикаций.',
      icon,
      title: 'Топ',
    },
  };
}

export function getStandardVasListItem(): VasListItem {
  const id = 'standard';

  const icon = <IconProductVasStandard16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    title: 'Стандарт',
    tooltip: {
      description: 'Объявления располагаются ниже объявлений с продвижением Топ и Премиум, но выше Публикаций.',
      icon,
      title: 'Стандарт',
    },
  };
}
